export default {
    loading: "Loading...",
    "reset-sent": "A reset link is en route to {email}",
    "check-inbox": "Please check your inbox to complete the reset process. You can now close this tab.",
    email: "Where should we send your reset link?",
};
